import { render, staticRenderFns } from "./Orderby2.vue?vue&type=template&id=ec48f3c8&scoped=true"
import script from "./Orderby2.vue?vue&type=script&lang=js"
export * from "./Orderby2.vue?vue&type=script&lang=js"
import style0 from "./Orderby2.vue?vue&type=style&index=0&id=ec48f3c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec48f3c8",
  null
  
)

export default component.exports